import { GetStaticProps } from 'next';

import { JobApplicationComponent } from '../../components/job-applications';
import { getServerTranslations } from '../../lib/i18n/getServerTranslations';

const CandidaturePage = () => <JobApplicationComponent />;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const transConfig = await getServerTranslations(locale, ['common', 'job-application-page', 'onboarding-page']);
  return {
    props: {
      ...transConfig,
    },
  };
};
export default CandidaturePage;
